<template>
  <apexchart
    ref="progressChart"
    type="radialBar"
    height="220"
    width="220"
    :options.sync="chartOptions"
    :series="series"
  ></apexchart>
</template>

<script>
export default {
  name: "NurseryFeProgressChart",

  props: {
    value: {
      default: 0,
    },
    color: {
      default: "#DF0000",
    },
  },

  data() {
    return {
      series: [this.value],
      chartOptions: {
        chart: {
          height: 350,
          type: "radialBar",
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "60%",
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                offsetY: 10,
                fontSize: "25px",
                fontWeight: "bolder",
                color: this.color,
              },
            },
          },
        },
        stroke: {
          lineCap: "round",
        },
        labels: ["Label"],
        fill: {
          colors: [this.color],
        },
      },
    };
  },

  watch: {
    value() {
      this.updateData();
    },
  },

  mounted() {
    this.updateData();
  },

  methods: {
    updateData() {
      const variants = {
        danger: "#DF0000",
        warning: "#e8670b",
        success: "#6e9a34",
      };
      const color = this.$options.filters.parse(this.value, "progressVariant");
      this.$refs.progressChart.updateOptions({
        plotOptions: {
          radialBar: {
            dataLabels: {
              value: {
                color: variants[color],
              },
            },
          },
        },
        fill: {
          colors: [variants[color]],
        },
      });
      this.$refs.progressChart.updateSeries([Math.floor(this.value)]);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/base/component/progress-chart.vue